<template>
  <div class="home-view">
    <div class="">
        <h1>Softron License Manager</h1>
        <p>Wait a second, redirecting to the correct page...</p>
        <p style="font-size: 10px;">test test test test test test test test test test test</p>
    </div>
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue';

import { useStore } from 'vuex';
const store = useStore()

import { useRouter } from 'vue-router'
const router = useRouter()

// --- REDIRECT ---
const isLoggedIn = computed(() => store.getters['user/isLoggedIn'])
watchEffect(() => {
    if (isLoggedIn.value) { router.push({ path: '/licenses' }) }
    else { router.push({ path: '/login' }) }
})
</script>

<style scoped>
</style>